export default __webpack_public_path__ + "static/media/Signin-ilustration.fd4ff524.svg";